import customerService from '@/api/customerService'
import Common from "../utils/common";
import wx from 'weixin-js-sdk'
var shareCommon = {};

// 是否已经有过刷新
shareCommon.hasRefreshCount = 0;

/**
 * 初始化微信JS-SDK签名
 * @param vm$store.state.mutations.isOpen
 * @returns {Promise.<T>}
 */
shareCommon.initWeiXinJSSignInfo = function(vm)
{
    // 初始化微信
    var setWeixinConfig = function(weixinConf)
    {
        var jsApiList = [
            'checkJsApi',  'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo',
            'hideMenuItems', 'showMenuItems','hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'getLocation',
            'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay','chooseImage','previewImage'];
        weixinConf.jsApiList = jsApiList;
        weixinConf.debug = false;
        wx.config(weixinConf);
    };

    wx.error(function(res) {
        if(res.errMsg.indexOf("invalid signature") >= 0) {
            if(shareCommon.hasRefreshCount >= 2)
            {
                shareCommon.hasRefreshCount = 0;
                // alert("微信获取签名错误，请刷新页面重试！错误描述：" + res.errMsg);
                return;
            }
            shareCommon.hasRefreshCount++;
            customerService.refreshWeiXinJSSignInfo(vm).then(function(config)
            {
                setWeixinConfig(config);
            });
        }
        else{
            // alert("微信注册出现错误，请刷新页面重试！错误描述：" + res.errMsg);
        }
    });

    // 初始化微信
    return customerService.getWechatSignInfo(vm).then(function(config){
            setWeixinConfig(config);
        },
        function(data) {
            // console.info("获取微信认证出现错误，请刷新页面或重新进入！错误描述：" + data);
        });
};

// 设置微信分享页面信息
shareCommon.setWeiXinShare = function(shareToInfo)
{
    // console.info("开始设置微信分享数据 infoModel = " + shareToInfo);
    // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
    wx.onMenuShareAppMessage({
        title: shareToInfo.title,
        desc: shareToInfo.desc,
        link: shareToInfo.link,
        imgUrl: shareToInfo.imgUrl,
        type: 'link',
        success: shareToInfo.success,
        cancel: shareToInfo.cancel
    });

    // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
    wx.onMenuShareTimeline({
        title: shareToInfo.title,
        link: shareToInfo.link,
        imgUrl: shareToInfo.imgUrl,
        success: shareToInfo.success,
        cancel: shareToInfo.cancel
    });

    // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
    wx.onMenuShareQQ({
        title: shareToInfo.title,
        desc: shareToInfo.desc,
        link: shareToInfo.link,
        imgUrl: shareToInfo.imgUrl,
        success: shareToInfo.success,
        cancel: shareToInfo.cancel
    });

    // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
    wx.onMenuShareWeibo({
        title: shareToInfo.title,
        desc: shareToInfo.desc,
        link: shareToInfo.link,
        imgUrl: shareToInfo.imgUrl,
        success: shareToInfo.success,
        cancel: shareToInfo.cancel
    });

    // 2.5 监听“分享到QQ空间”按钮点击状态及自定义分享内容接口
    wx.onMenuShareQZone({
        title: shareToInfo.title,
        desc: shareToInfo.desc,
        link: shareToInfo.link,
        imgUrl: shareToInfo.imgUrl,
        success: shareToInfo.success,
        cancel: shareToInfo.cancel
    });
};

/**
 * 初始化活动分享
 * @param vm
 * @param crowdBase 活动信息
 * @param weichatShareUrl 微信分享链接
 */
shareCommon.initShare = function(vm, crowdBase,weichatShareUrl)
{
    //配置微信分享信息
    var infoModel={};
    infoModel.title = crowdBase.name;
    infoModel.imgUrl = crowdBase.coverUrl;
    infoModel.desc = crowdBase.remarks;
    infoModel.type = 'link';
    infoModel.success = function()
    {
        Common.PageOperator.showPromptMsg(vm, true, '分享成功', 'success');
    };
    infoModel.cancel= function()
    {
        // Common.PageOperator.showPromptMsg(vm,'您取消了分享');
    };
    infoModel.link = window.location.href;
    wx.ready(function(){
        shareCommon.setWeiXinShare(infoModel);
    });
    shareCommon.setWeiXinShare(infoModel);
};
export default shareCommon;



// WEBPACK FOOTER //
// ./src/js/shareCommon.js